<div class="flex gap-4">
  @if (!isMobile) {
    <div
      role="radiogroup"
      [attr.aria-label]="dayOfWeekGroupAriaLabel"
      class="flex flex-wrap gap-4"
      >
      <!-- div + role="radio": avoid native button click earcon when moving with SR + arrows -->
      @for (dayOption of dayOptionsList; track dayOption; let i = $index) {
        <div
          #dayRadioBtn
          role="radio"
          [attr.aria-checked]="isDaySelected(dayOption)"
          [attr.aria-label]="dayOption.ariaLabel || dayOption.label"
          [attr.tabindex]="tabIndexForDay(dayOption)"
          class="bg-[#E7EAEE] rounded-full w-[2.5rem] h-[2.5rem] text-sm font-normal cursor-pointer p-0 flex items-center justify-center outline-none"
      [ngClass]="{
        'bg-[#FFFFFF]': isDaySelected(dayOption),
        'border-solid border border-black': isDaySelected(dayOption),
        'border-0': !isDaySelected(dayOption)
      }"
          (click)="pickDay(dayOption.value)"
          (keydown)="onDayRadioKeydown($event, i)"
          >
          {{ dayOption.label }}
        </div>
      }
    </div>
  }

  @if (isMobile) {
    <mot-select
      [formControl]="formControl"
      [displayErrors]="false"
      class="w-full !text-default"
      [label]="dayText"
      [options]="dayOptions"
      >
    </mot-select>
  }
</div>
